import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CreateTimesheetDTO,
  TimesheetGetDTO,
  UpdateTimesheetDTO,
  WorkLogGetDetailDTO,
} from './timesheet.model';
import { withNoMessageToast } from '../../core/interceptors/http-toast.interceptor';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TimesheetsService {
  private base = '/api/work-logs';

  constructor(private http: HttpClient) {}

  private cleanParams(params: { [key: string]: any }): { [key: string]: any } {
    const clean: { [key: string]: any } = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== null && value !== undefined && value !== '') {
        clean[key] = value;
      }
    });
    return clean;
  }

  /** Fetch all entries for a user for the week starting at startDate (ISO) */
  getTimeSheet(
    startDate: string,
    endDate: string,
    employeeId?: string,
    clientId?: string
  ): Observable<TimesheetGetDTO[]> {
    const params = new HttpParams({
      fromObject: this.cleanParams({
        startDate,
        endDate,
        employeeId,
        clientId,
      }),
    });

    return this.http
      .get<{ data: TimesheetGetDTO[] }>(
        `${environment.baseApiUrl}${this.base}`,
        {
          params,
          context: withNoMessageToast(),
        }
      )
      .pipe(
        map((res) => res.data),
        catchError(() => of([]))
      );
  }

  getTimeSheetById(
    worklogId: string | null
  ): Observable<WorkLogGetDetailDTO | null> {
    return this.http
      .get<WorkLogGetDetailDTO>(
        `${environment.baseApiUrl}${this.base}/${worklogId}`
      )
      .pipe(catchError(() => of(null)));
  }

  /** Create a new timesheet entry */
  createTimesheet(payload: CreateTimesheetDTO): Observable<any> {
    return this.http.post<any>(
      `${environment.baseApiUrl}${this.base}`,
      payload
    );
  }

  updateTimesheet(payload: UpdateTimesheetDTO) {
    return this.http.put<any>(`${environment.baseApiUrl}${this.base}`, payload);
  }

  deleteWorklog(worklogId: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.baseApiUrl}${this.base}/${worklogId}`
    );
  }
}
